var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduledMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.3307V17.3307L13.3333 13.9974L0 10.6641V0.664062L23.8333 10.6641H23.3333C20.0833 10.6641 17.3267 11.8096 15.0633 14.1007C12.7989 16.393 11.6667 19.1641 11.6667 22.4141L0 27.3307ZM23.3333 30.6641C21.0278 30.6641 19.0628 29.8518 17.4383 28.2274C15.8128 26.6018 15 24.6363 15 22.3307C15 20.0252 15.8128 18.0596 17.4383 16.4341C19.0628 14.8096 21.0278 13.9974 23.3333 13.9974C25.6389 13.9974 27.6044 14.8096 29.23 16.4341C30.8544 18.0596 31.6667 20.0252 31.6667 22.3307C31.6667 24.6363 30.8544 26.6018 29.23 28.2274C27.6044 29.8518 25.6389 30.6641 23.3333 30.6641ZM26.0833 26.2474L27.25 25.0807L24.1667 21.9974V17.3307H22.5V22.6641L26.0833 26.2474Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledMessage);
export default __webpack_public_path__ + "static/media/scheduledMessage.c476f7a50b2c39fe25bbac7aa9047593.svg";
export { ForwardRef as ReactComponent };